
let initialized = false;
let globalDoResize = null;
let globalMinHeight = 150;

const resize = () => {
  const b = document.querySelector('body');
  const offsetHeight = b.offsetHeight + 10;
  globalDoResize({
    height: `${Math.max(offsetHeight, globalMinHeight)}px`
  });
};

export const initializeResizer = (minHeight, doResize) => {
  if (initialized) return;
  initialized = true;
  globalDoResize = doResize;
  globalMinHeight = minHeight;
  const b = document.querySelector('body');
  window.addResizeListener(b, resize);
  resize();
};

export const changeMinHeight = (minHeight) => {
  globalMinHeight = minHeight;
  resize();
};
